/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatManagementEditChatStatusRequest } from '../models/ChatManagementEditChatStatusRequest';
import type { ChatManagementEditChatStatusResponseApiRespoonse } from '../models/ChatManagementEditChatStatusResponseApiRespoonse';
import type { ChatManagementEditIsReadedRequest } from '../models/ChatManagementEditIsReadedRequest';
import type { ChatManagementEditIsReadedResponseApiRespoonse } from '../models/ChatManagementEditIsReadedResponseApiRespoonse';
import type { ChatManagementEditStatusRequest } from '../models/ChatManagementEditStatusRequest';
import type { ChatManagementEditStatusResponseApiRespoonse } from '../models/ChatManagementEditStatusResponseApiRespoonse';
import type { ChatManagementGetTokenRequest } from '../models/ChatManagementGetTokenRequest';
import type { ChatManagementGetTokenResponseApiRespoonse } from '../models/ChatManagementGetTokenResponseApiRespoonse';
import type { ChatManagementListMessageRequest } from '../models/ChatManagementListMessageRequest';
import type { ChatManagementListMessageResponseApiRespoonse } from '../models/ChatManagementListMessageResponseApiRespoonse';
import type { ChatManagementSaveMessageRequest } from '../models/ChatManagementSaveMessageRequest';
import type { ChatManagementSaveMessageResponseApiRespoonse } from '../models/ChatManagementSaveMessageResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ChatManagementService {

    /**
     * list chat
     * @param requestBody
     * @returns ChatManagementListMessageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatList(
        requestBody: ChatManagementListMessageRequest,
    ): CancelablePromise<ChatManagementListMessageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/list',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * save chat
     * @param requestBody
     * @returns ChatManagementSaveMessageResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatSave(
        requestBody: ChatManagementSaveMessageRequest,
    ): CancelablePromise<ChatManagementSaveMessageResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/save',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get token
     * @param requestBody
     * @returns ChatManagementGetTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatConnectSocketUrl(
        requestBody: ChatManagementGetTokenRequest,
    ): CancelablePromise<ChatManagementGetTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/connect-socket-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * edit is readed
     * @param requestBody
     * @returns ChatManagementEditIsReadedResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatIsReaded(
        requestBody: ChatManagementEditIsReadedRequest,
    ): CancelablePromise<ChatManagementEditIsReadedResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/is-readed',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * edit is status of order
     * @param requestBody
     * @returns ChatManagementEditStatusResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatOrderStatus(
        requestBody: ChatManagementEditStatusRequest,
    ): CancelablePromise<ChatManagementEditStatusResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/order-status',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * edit is status of order
     * @param requestBody
     * @returns ChatManagementEditChatStatusResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminChatChatStatus(
        requestBody: ChatManagementEditChatStatusRequest,
    ): CancelablePromise<ChatManagementEditChatStatusResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/chat/chat-status',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
